module.exports = __webpack_public_path__ + "img/SC7-occupation.c5e7e8db.png";